// extracted by mini-css-extract-plugin
export default {"activateUser":"ActivateUser_activateUser__lFInE"};